import { defineType } from 'sanity';

export const contactPage = defineType({
    name: 'contact_page',
    title: 'Contact Page',
    type: 'document',
    fields: [
        {
            name: 'domainName',
            title: 'Domain Name',
            type: 'string',
        },
        {
            name: 'seo',
            title: 'SEO Settings',
            type: 'seo',
            description: 'Search engine optimization settings for better visibility',
        },
    ],
    preview: {
        select: {
            title: 'domainName',
        },
    },
});
